import React from 'react';
import { Link, LinkProps } from 'react-router-dom';
import { useTheme } from '@material-ui/core';

export const AppLink = React.forwardRef((props: LinkProps, ref) => {
  const theme = useTheme();
  return <Link style={{ color: theme.palette.secondary.main }} {...props} />;
});
